export default __webpack_public_path__ + "static/media/Lupa.174f85eb.svg";